const prioritMap: Record<number, string> = {
  1: 'Primary',
  2: 'Secondary',
  3: 'Tertiary',
};

export function formatSelectionPriority(priority: number) {
  return prioritMap[priority];
}
